import DeleteSpecDetailCOMContainer from "./DeleteSpecDetailCOMContainer";
export default DeleteSpecDetailCOMContainer;
